// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SystemInfo" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";

export const SystemInfoGenShape = z.strictObject({
  environment: z.string(),
  serverCommit: z.string(),
  buildId: z.string(),
  cosmosEndpoint: z.string(),
  dataCollection: z.string(),
  statsCollection: z.string(),
  cdnUrl: z.string(),
  appInsightsKey: z.string(),
  pdfEngine: z.string(),
  sqlServer: z.string(),
  sqlDatabase: z.string(),
  sqlConnected: z.boolean(),
  cosmosReachable: z.boolean(),
});
